const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"vbjwss9SBlaiKcGF1EtCL"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sea-museum-ticketing-web@sea-museum"]={id:"vbjwss9SBlaiKcGF1EtCL"};
      